module.exports = __webpack_public_path__ + "img/sort_down.02b6e8de.svg";